import { FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'CompanyName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderId',
    field: FIELDS.SHIPPING_PROVIDER_ID,
    title: ' Shipping Provider Id',
    label: 'ShippingProviderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: ' Shipping Provider Name',
    label: 'ShippingProviderName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountNumber',
    field: FIELDS.ACCOUNT_NUMBER,
    title: ' Account Number',
    label: 'AccountNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserName',
    field: FIELDS.CREATED_BY_USER_NAME,
    title: ' Created By User Name',
    label: 'CreatedByUserName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserName',
    field: FIELDS.MODIFIED_BY_USER_NAME,
    title: ' Modified By User Name',
    label: 'ModifiedByUserName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  // {
  //   field: 'deletecommands',
  //   title: ' ',
  //   cell: 'deletecommands',
  //   headerCell: 'commandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
]

export default defaultFields;
